import React, { useState, useEffect } from "react";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { Permis } from "./components/permis";
import { About } from "./components/about";
import { Avis } from "./components/avis";
import { Contact } from "./components/contact";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";
import {Label} from "./components/label";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <div>
      <Navigation />
      <Header data={landingPageData.Header} />
      <Permis data={landingPageData.Permis} />
      <About data={landingPageData.About} />
      <Avis data={landingPageData.Api} />
      <Label data={landingPageData.Labels} />
      <Contact data={landingPageData.Contact} />
    </div>
  );
};

export default App;
